import { faSave, faTrashAlt } from "@fortawesome/free-regular-svg-icons";
import { faArrowLeftLong, faEdit } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";

export const TutorialPreview = ({ data, savePrev }) => {

    const [tmpData, setTmpData] = useState(data);
    const letterIndexes = ['a', 'b', 'c', 'd','e'];
    const [upDated, setUpdated] = useState();

    const handleSave = () => {
        savePrev(tmpData);
    }

    /**
     * 
     * @param {*} val string value to be changed
     * @param {*} indx index of the question unit
     * @param {*} lettr the letter key of the answer
     */
    const handleUpdateAnswers = (val, indx, lettr) => {
        setTmpData((prevData) =>
            prevData.map((item, index) => {
                if (index === indx) {
                    return {
                        ...item,
                        answers: {
                            ...item.answers,
                            [lettr]: val
                        }
                    };
                }
                return item;
            })
        );
    }

    return (
        <div className="preview-container">
            <button
                className="adm-add opt-q-button"
                onClick={handleSave}
            >
                <span>Save Preview</span>
                <FontAwesomeIcon icon={faArrowLeftLong} />
            </button>
            {!upDated ?
                <div>
                    {tmpData.map((questionObj, indx) => {

                        const answerArr = Object.values(questionObj.answers);

                        return (
                            <div className="question-unit" key={indx}>
                                <div className="q-unit-header">
                                    <span className="q-num">{indx + 1}</span>
                                    <span className="q-question">{questionObj.question}</span>
                                    <div className="ctrl-buttons">
                                        <button
                                            className="update-prompt"
                                            onClick={() => setUpdated({
                                                questionObj: {
                                                    question: questionObj.question,
                                                    answers: {
                                                        "a": questionObj.answers["a"] || '',
                                                        "b": questionObj.answers["b"] || '',
                                                        "c": questionObj.answers["c"] || '',
                                                        "d": questionObj.answers["d"] || '',
                                                        "e": questionObj.answers["e"] || ''
                                                    },
                                                    answer: questionObj.answer
                                                },
                                                qnum: indx + 1
                                            })}
                                        >
                                            <FontAwesomeIcon icon={faEdit} />
                                        </button>
                                        <button className="update-prompt">
                                            <FontAwesomeIcon icon={faTrashAlt} />
                                        </button>
                                    </div>
                                </div>
                                {answerArr.map((answ, k) => (
                                    <input
                                        type="text"
                                        className="prev-edit-input"
                                        value={tmpData[indx]['answers'][letterIndexes[k]]}
                                        onChange={() => {
                                            handleUpdateAnswers(answ, indx, letterIndexes[k]);
                                            setUpdated(indx);
                                        }}
                                    />
                                ))}
                            </div>
                        )
                    })}
                </div> :
                <div>
                    <div className="question-unit" >
                        <div className="q-unit-header">
                            <span className="q-num">{upDated.qnum}</span>
                            <span className="q-question">{upDated.questionObj.question}</span>

                            <button
                                className="update-prompt"
                                onClick={() => {
                                    setTmpData((data) => data.map((val, indx) => {
                                        if (indx === upDated.qnum - 1) {
                                            return ({
                                                question: upDated.questionObj.question,
                                                answers: {
                                                    "a": upDated.answers["a"],
                                                    "b": upDated.answers["b"],
                                                    "c": upDated.answers["c"],
                                                    "d": upDated.answers["d"]
                                                },
                                                answer: upDated.answer
                                            })
                                        }
                                        return val;
                                    }));
                                    setUpdated();
                                }}
                            >
                                <FontAwesomeIcon icon={faSave} />
                            </button>
                        </div>
                        {Object.values(upDated.questionObj.answers).map((answ, k) => (
                            <input
                                type="text"
                                className="prev-edit-input"
                                value={upDated.questionObj.answers[letterIndexes[k]] || null}
                                onChange={(e) => {
                                    setUpdated((prev) => ({
                                        ...prev,
                                        answers: {
                                            ...prev.answers,
                                            [letterIndexes[k]]: e.target.value
                                        }
                                    }))
                                }}
                            />
                        ))}
                    </div>
                </div>
            }
        </div>
    )
}